import { type ReactElement } from 'react';
import { Navigate, useLocation, useParams, useSearchParams } from 'react-router-dom';

/**
 * Copies a path param into the query (and optional localStorage) so existing
 * feature pages keep working while entity identity lives in the URL.
 */
export function PathQueryBridge({
  pathKey,
  queryKey,
  storageKey,
  children,
}: {
  pathKey: string;
  queryKey: string;
  storageKey?: string;
  children: ReactElement;
}) {
  const params = useParams();
  const [sp] = useSearchParams();
  const location = useLocation();
  const id = params[pathKey];

  if (id && storageKey) {
    try {
      localStorage.setItem(storageKey, id);
    } catch {
      /* ignore */
    }
  }

  if (id && sp.get(queryKey) !== id) {
    const next = new URLSearchParams(sp);
    next.set(queryKey, id);
    return <Navigate to={`${location.pathname}?${next.toString()}`} replace />;
  }

  return children;
}
